import { render } from "./DashboardPanelRanking.vue?vue&type=template&id=7181f66d&scoped=true"
import script from "./DashboardPanelRanking.vue?vue&type=script&lang=js"
export * from "./DashboardPanelRanking.vue?vue&type=script&lang=js"

import "./DashboardPanelRanking.vue?vue&type=style&index=0&id=7181f66d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7181f66d"]])

export default __exports__